import api from '../../../api';

export function getInstancias(value: string) {
  return api.get(`/instancias/subs/login/${value}`);
}

export const postResetPassword = (value : any) => {
  return api.post(`/usuarios/reset-password`, value);
}
